@if ($socket().type) {
    <div class="cm-name" [class.cm-output-name]="$socket().type === 'output'" [class.cm-input-name]="$socket().type === 'input'">
        @if ($socket().inputField) {
            @switch ($valueType()) {
                @case ("closure") {
                    <cm-plain-input-socket [label]="$socket().label" [connected]="$connected()" [value]="$valueAsString()"></cm-plain-input-socket>
                }
                @case ("float") {
                    <cm-scalar-input-socket
                        [range]="$range()"
                        [type]="$socket().type"
                        [label]="$socket().label"
                        [connected]="$connected()"
                        [value]="$valueAsNumber()"
                        (valueChange)="changeValue({value: $event, type: 'float'})"
                        [disableEditingIfConnected]="$disableEditingIfConnected()"
                    >
                    </cm-scalar-input-socket>
                }
                @case ("int") {
                    <cm-scalar-input-socket
                        [range]="$range()"
                        [type]="$socket().type"
                        [label]="$socket().label"
                        [connected]="$connected()"
                        [value]="$valueAsNumber()"
                        (valueChange)="changeValue({value: $event, type: 'int'})"
                        [disableEditingIfConnected]="$disableEditingIfConnected()"
                    >
                    </cm-scalar-input-socket>
                }
                @case ("color") {
                    <cm-color-input-socket
                        [type]="$socket().type"
                        [label]="$socket().label"
                        [connected]="$connected()"
                        [value]="$valueAsColor()"
                        (valueChange)="changeValue({value: $event, type: 'color'})"
                        [disableEditingIfConnected]="$disableEditingIfConnected()"
                    >
                    </cm-color-input-socket>
                }
                @case ("vector") {
                    <cm-vector-input-socket
                        [label]="$socket().label"
                        [connected]="$connected()"
                        [value]="$valueAsVec3()"
                        (valueChange)="changeValue({value: $event, type: 'vector'})"
                    >
                    </cm-vector-input-socket>
                }
                @case ("normal") {
                    <cm-vector-input-socket
                        [label]="$socket().label"
                        [connected]="$connected()"
                        [value]="$valueAsVec3()"
                        (valueChange)="changeValue({value: $event, type: 'normal'})"
                    >
                    </cm-vector-input-socket>
                }
                @case ("point") {
                    <cm-vector-input-socket
                        [label]="$socket().label"
                        [connected]="$connected()"
                        [value]="$valueAsVec3()"
                        (valueChange)="changeValue({value: $event, type: 'normal'})"
                    >
                    </cm-vector-input-socket>
                }
                <!--            @case ("output") {-->
                <!--                &lt;!&ndash; TODO separate component also for the 'output' type ? &ndash;&gt;-->
                <!--                <div>{{ $socket().label }}</div>-->
                <!--            }-->
                <!--            @case ("input") {-->
                <!--                &lt;!&ndash; TODO separate component also for the 'input' type ? &ndash;&gt;-->
                <!--                <div>{{ $socket().label }}</div>-->
                <!--            }-->
            }
        } @else {
            <cm-plain-input-socket [label]="$socket().label" [connected]="$connected()" [value]="$valueAsString()"></cm-plain-input-socket>
        }
    </div>
    @if ($socket().type === "input") {
        <ng-container *ngTemplateOutlet="socketTemplate"></ng-container>
    }
    @if ($socket().type === "output") {
        <ng-container *ngTemplateOutlet="socketTemplate"></ng-container>
    }
    <ng-template #socketTemplate>
        <cm-node-socket #socketComponent [nodeId]="$nodeId()" [socketId]="$socket().id" [valueType]="$socket().valueType" [type]="$socket().type">
        </cm-node-socket>
    </ng-template>
}
